export default {
    name: "BulmaField",
    props: {
        'label': {
            type: String,
            required: true,
        },
        'icon': {
            type: String,
            required: true,
        },
        'labelWidth': {
            type: String,
            required: true,
        }
    },
    data: () => ({
        'value': '',
        'error': '',
        'inputId': Math.random().toString(36)
    })
};
